import copyToOtherListsModalTemplate from '../../../views/workflows/copy-rsvps-to-guestlists-modal.tpl.html';

angular
    .module('festzelt-os.guestlists')
    .factory('copyRsvpsToOtherLists', [
        '$injector',
        ($injector) => new CopyRsvpsToOtherLists($injector)
    ]);


class CopyRsvpsOtherListsModalController {
    constructor($injector, $uibModalInstance) {
        this.injector = $injector;
        this.modalInstance = $uibModalInstance;
        this.requestModel = {
            keep_customs: false,
            keep_codes: true
        };
        this.guestlistsStore = this.injector.get('Guestlists').reset({
            persist: false,
            listview: 'CopyRsvpsToOtherListsSelector'
        });
        this.selectedGuestlists = [];
        this.selectAllGuestlists = false;

        this.guestlistsSelectConfig = {
            store: this.guestlistsStore,
            displayField: 'name',
            valueField: 'id',
            maxItems: 500,
            disabled: this.selectAllGuestlists,
            sortField: [
                {
                    field: 'id',
                    direction: 'asc'
                },
                {
                    field: '$score'
                }
            ]
        };
    }

    close() {
        this.modalInstance.close({
            ...this.requestModel,
            guestlists: this._getGuestlistsSelectorData()
        });
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    _getGuestlistsSelectorData() {
        if (this.selectAllGuestlists) {
            this.guestlistsStore.commit('setSelectAll', true);
            return this.guestlistsStore.getters.selectedFilters;
        } else {
            return {
                count: this.selectedGuestlists.length,
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: this.selectedGuestlists
                    }
                ]
            }
        }
    }

    validateCurrentData() {
        return this.selectedGuestlists.length > 0 || this.selectAllGuestlists;
    }
}

CopyRsvpsOtherListsModalController.$inject = [
    '$injector',
    '$uibModalInstance'
];

class CopyRsvpsToOtherLists {
    constructor($injector) {
        this.injector = $injector;

        this.modal = this.injector.get('$uibModal');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');

        this.key = 'copy-rsvps-to-other-lists';
        this.title = 'Copy to Guestlists';
        this.level = 'selected';
    }

    action({action}, rsvpStore) {
        this.modal.open({
            templateUrl: copyToOtherListsModalTemplate,
            controller: CopyRsvpsOtherListsModalController,
            controllerAs: 'vm'
        }).result.then((selectorInformation) => {
            this.api.post('rsvps/copy-to-other-lists', {
                ...selectorInformation,
                rsvps: rsvpStore.getters.selectedFilters
            }).then((selectorInformation) => {
                this.alert.success('Job started', 'The copy process was started.');
            }, () => {
                this.alert.error('Start failed', 'The start of the copy process has failed. Please retry');
            });
        }, () => {
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/copy-rsvps-to-other-lists.js